import "./policy-pages.css";

export default function PrivacyPolicy() {
  return (
    <>
<section className="policy-page">
  <header className="policy-header">
    <a className="back-link" href="/">← Back to Home</a>
    <h1>Privacy Policy</h1>
    <p>This Privacy Policy explains how Web5Solution collects, uses, protects, and handles personal information when you visit our website, contact us, or use our services.</p>
  </header>

  <main className="policy-content">
    <p><strong>Last Updated:</strong> 26 June 2026</p>

    <div className="notice">
      By using our website or contacting Web5Solution, you agree to the practices described in this Privacy Policy.
    </div>

    <h2>1. Information We Collect</h2>
    <p>We may collect information that you voluntarily provide to us when you contact us, submit a form, request a proposal, or communicate with our team.</p>

    <h3>Personal Information</h3>
    <ul>
      <li>Name</li>
      <li>Email address</li>
      <li>Phone number</li>
      <li>Company name</li>
      <li>Project requirements or business details</li>
      <li>Any other information you choose to share with us</li>
    </ul>

    <h3>Technical Information</h3>
    <p>When you visit our website, we may automatically collect limited technical information, such as:</p>
    <ul>
      <li>IP address</li>
      <li>Browser type and version</li>
      <li>Device type and operating system</li>
      <li>Pages visited and time spent on the website</li>
      <li>Referral source</li>
      <li>Cookies and similar usage data</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <p>We use the information we collect for business and service-related purposes, including to:</p>
    <ul>
      <li>Respond to inquiries and communication</li>
      <li>Understand project requirements</li>
      <li>Prepare proposals, quotations, and service information</li>
      <li>Deliver technology, blockchain, Web3, AI, automation, and software-related services</li>
      <li>Improve our website, services, and customer experience</li>
      <li>Maintain security and prevent misuse</li>
      <li>Comply with legal, regulatory, or contractual obligations</li>
    </ul>

    <h2>3. Cookies and Tracking Technologies</h2>
    <p>Our website may use cookies and similar technologies to improve website functionality, analyze traffic, and understand visitor behavior.</p>
    <p>You can disable cookies through your browser settings. Some parts of the website may not function properly if cookies are disabled.</p>

    <h2>4. Sharing of Information</h2>
    <p>We do not sell, rent, or trade your personal information. We may share information only where reasonably required, such as with:</p>
    <ul>
      <li>Internal team members involved in your inquiry or project</li>
      <li>Trusted service providers who help us operate our website or business</li>
      <li>Legal, regulatory, or government authorities when required by law</li>
      <li>Professional advisors such as legal, accounting, or compliance consultants</li>
    </ul>

    <h2>5. Data Security</h2>
    <p>We use reasonable technical and organizational measures to protect personal information from unauthorized access, misuse, loss, alteration, or disclosure.</p>
    <p>However, no internet transmission or electronic storage method is completely secure, so we cannot guarantee absolute security.</p>

    <h2>6. Data Retention</h2>
    <p>We retain personal information only for as long as necessary to fulfill the purposes described in this Privacy Policy, including business, legal, accounting, reporting, and dispute-resolution requirements.</p>

    <h2>7. Your Rights</h2>
    <p>Depending on applicable law, you may have the right to:</p>
    <ul>
      <li>Access the personal information we hold about you</li>
      <li>Request correction of inaccurate or incomplete information</li>
      <li>Request deletion of your personal information</li>
      <li>Withdraw consent where processing is based on consent</li>
      <li>Raise concerns about how your personal information is handled</li>
    </ul>
    <p>To exercise these rights, please contact us using the details provided below.</p>

    <h2>8. Third-Party Links</h2>
    <p>Our website may contain links to third-party websites, platforms, APIs, tools, or services. We are not responsible for the privacy practices, content, security, or policies of third-party websites.</p>

    <h2>9. Children’s Privacy</h2>
    <p>Our website and services are not intended for children under the age of 18. We do not knowingly collect personal information from children.</p>
    <p>If you believe that a child has provided personal information to us, please contact us and we will take appropriate steps to remove such information.</p>

    <h2>10. International Data Transfer</h2>
    <p>Depending on the tools, hosting providers, cloud platforms, and service providers we use, your information may be processed or stored outside your country of residence.</p>
    <p>Where required, we take reasonable steps to ensure that your information is protected according to applicable laws.</p>

    <h2>11. Changes to This Privacy Policy</h2>
    <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated “Last Updated” date.</p>
    <p>Your continued use of our website after changes are posted means you accept the updated Privacy Policy.</p>

    <h2>12. Contact Us</h2>
    <div className="contact-box">
      <p><strong>Web5Solution</strong></p>
      <p>Email: <a href="mailto:info@web5solution.com">info@web5solution.com</a></p>
      <p>Website: <a href="https://web5solution.com/">https://web5solution.com/</a></p>
      <p>Address: 19A, Ground Floor, Tower B3, Spaze i-Tech Park, Sohna Road, Sector 49, Gurugram, Haryana 122018, India</p>
    </div>
  </main>

  
</section>
    </>
  );
}
